import { IBlock } from 'common/builder/blocks/blockInterfaces'
import {
  ConverterRule,
  EmailContentRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { EmailContent } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

import { EmailAttachmentContentConverterRule } from './EmailAttachmentContentConverterRule'
import { EmailButtonContentConverterRule } from './EmailButtonContentConverterRule'
import { EmailFallbackContentConverterRule } from './EmailFallbackContentConverterRule'
import { EmailPreviewContentConverterRule } from './EmailPreviewContentConverterRule'
import { EmailTextContentConverterRule } from './EmailTextContentConverterRule'

export const EmailContentContverterRules: Array<
  ConverterRule<IBlock, EmailContent, EmailContentRulePayload>
> = [
  EmailTextContentConverterRule,
  EmailButtonContentConverterRule,
  EmailAttachmentContentConverterRule,
  EmailPreviewContentConverterRule,
  EmailFallbackContentConverterRule,
]
